<template>
<div class="chapter">
<div class="inner_page">
      ﻿
<title>Among the Fair Magnolias: Four Southern: Love Stories</title><link href="css/default.css" rel="stylesheet" type="text/css"/>
<p class="crt" id="sec-7"><br/><br/></p>
<p class="ct" id="Azc"><a id="page_vii"><img alt="images/img-7-1.jpg" id="pz7-1" src="images/img-7-1.jpg" style="vertical-align: middle;"/>CONTENTS<img alt="images/img-7-2.jpg" id="AMgx" src="images/img-7-2.jpg" style="vertical-align: middle;"/></a></p><a id="page_vii">
</a><p class="cct"><a id="page_vii"></a><a href="#/dedication01">Dedication</a></p>
<p class="cct"><a href="#/chapter01#con1" id="toc1">A Note from the Author</a></p>
<p class="cct"><a href="#/chapter02#con2" id="toc2">Chapter One</a></p>
<p class="cct"><span href="#/chapter03#con3" id="toc3" title="Link target outside of Sample">Chapter Two</span></p>
<p class="cct"><span href="#/chapter04#con4" id="toc4" title="Link target outside of Sample">Chapter Three</span></p>
<p class="cct"><span href="#/chapter05#con5" id="toc5" title="Link target outside of Sample">Chapter Four</span></p>
<p class="cct"><span href="#/chapter06#con6" id="toc6" title="Link target outside of Sample">Chapter Five</span></p>
<p class="cct"><span href="#/chapter07#con7" id="toc7" title="Link target outside of Sample">Chapter Six</span></p>
<p class="cct"><span href="#/chapter08#con8" id="toc8" title="Link target outside of Sample">Chapter Seven</span></p>
<p class="cct"><span href="#/chapter09#con9" id="toc9" title="Link target outside of Sample">Chapter Eight</span></p>
<p class="cct"><span href="#/chapter57#con56" id="toc56" title="Link target outside of Sample">Acknowledgments</span></p>
<p class="cct"><span href="#/chapter56#con55" id="toc55" title="Link target outside of Sample">Discussion Questions</span></p>
<p class="cct"><span href="#/chapter55#con54" id="toc54" title="Link target outside of Sample">Recipe</span></p>
<p class="cct"><span href="#/chapter58#con57" id="toc57" title="Link target outside of Sample">About the Author</span></p>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// contents.vue?42312ce4